export default __webpack_public_path__ + "static/media/csv-icon.1d2cc548.png";